import { render, staticRenderFns } from "./pdf-preview.vue?vue&type=template&id=54949d75&scoped=true"
import script from "./pdf-preview.vue?vue&type=script&lang=js"
export * from "./pdf-preview.vue?vue&type=script&lang=js"
import style0 from "./pdf-preview.vue?vue&type=style&index=0&id=54949d75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54949d75",
  null
  
)

export default component.exports